import React, { Component } from 'react'
import { Col, Row, Input, Label } from 'reactstrap'
import ModalForm from '../../../comum/components/ModalForm'
import { observer } from 'mobx-react'
import NovoDirecionamentoStore from '../stores/NovoDirecionamentoStore'
import modeloTecon from '../../../../assets/downloads/Planilha_direcionamento_Tecon.xlsx'

@observer
export default class ImportarDirecionamento extends Component {

    constructor(props) {
        super(props)

        this.direcController = this.props.controller

        this.controller = new NovoDirecionamentoStore(this.direcController.service)

        this.handleSalvar = this.handleSalvar.bind(this)
    }

    handleSalvar() {
        this.controller.listaImportacao.map(imp => {
            this.direcController.adicionarListaAdicoes(imp.CeHouse,imp.Email,imp.CodRef,[])
        })
        this.direcController.mostrarTabelaAdicionar()
        this.direcController.fecharModalImportar()
    }

    render() {
        return (
            <ModalForm
                className="modal-direcionamento"
                salvando={this.controller.loadingImport}
                onClickSalvar={this.handleSalvar}
                labelConfirmar="confirmar"
                esconderSalvar={this.controller.listaImportacao.length === 0}
                onClickCancelar={this.direcController.fecharModalImportar}
            >
                <h2>
                    Importar xls
                </h2>
                <Row>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Label>Anexos</Label>
                        <span className="label-danger">*</span>
                        <Input className="p-2 mb-4" type="file" onChange={e => this.controller.adicionarPlanilha(e)} accept=".csv, .xml, .txt, .xls, .xlsx, .doc, .pdf" multiple />
                        <Label className="mb-0"><a href={modeloTecon} download="modelo_direcionamento_Tecon.xlsx">Baixar modelo de planilha</a></Label>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        {this.controller.aviso && <div className='label-obrigatorio pt-2 pb-1'>
                            <Label>{ this.controller.aviso }</Label>
                        </div>}
                    </Col>
                </Row>
            </ModalForm>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/direcionamento/tecon/components/ImportarDirecionamento.js